import styled from "@emotion/styled";
import _ from "lodash";
import { useEffect, useMemo } from "react";
import { useRecoilState, useSetRecoilState } from "recoil";
import { IsDefaultStatusAtom } from "../../../atoms/ContactFilterAtom";
import { FilterCounterAtom } from "../../../atoms/ContactFilterAtoms";
import { ContactFiltersAtom } from "../../../atoms/ContactFiltersAtom";
import { ContactStatus } from "../../../types/Contact";
import { notSelect } from "../../../utils/HelperStyles";
import StyledCheckBox from "../../StyledCheckBox";

const STATUS = [
  { name: "Admin Unsubscribed", value: ContactStatus.ADMIN_UNSUBSCRIBED },
  { name: "Confirmed", value: ContactStatus.CONFIRMED },
  { name: "Not Confirmed", value: ContactStatus.NOT_CONFIRMED },
  { name: "Pending Confirmation", value: ContactStatus.PENDING_CONFIRMATION },
  { name: "Spam", value: ContactStatus.SPAM },
  { name: "Bot Filled", value: ContactStatus.BOT_FILLED },
  { name: "Suppressed", value: ContactStatus.SUPRESSED },
  { name: "Suspended", value: ContactStatus.SUSPENDED },
  { name: "Unsubscribed", value: ContactStatus.UNSUBSCRIBED },
  { name: "Blocked", value: "BLOCKED" },
];

export const allStatusArray = [
  ContactStatus.CONFIRMED,
  ContactStatus.NOT_CONFIRMED,
  ContactStatus.ADMIN_UNSUBSCRIBED,
  ContactStatus.UNSUBSCRIBED,
  ContactStatus.SUPRESSED,
  ContactStatus.SPAM,
  ContactStatus.BOT_FILLED,
  ContactStatus.SUSPENDED,
  ContactStatus.PENDING_CONFIRMATION,
];

const ItemDiv = styled.div`
  display: flex;
  align-items: center;
  margin: 5px 0px;
  cursor: pointer;
  ${notSelect}
`;

export const FilterName = styled.div`
  margin-left: 15px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
`;

export default function FilterByStatus() {
  const setFilterCounter = useSetRecoilState(FilterCounterAtom);
  const [contactFilters, setContactFilters] =
    useRecoilState(ContactFiltersAtom);
  const [isDefaultStatus, setIsDefaultStatus] =
    useRecoilState(IsDefaultStatusAtom);

  function onFilterStatusChange(vle: ContactStatus, isChecked: boolean) {
    let newStatus: ContactStatus[] = isDefaultStatus
      ? []
      : contactFilters.status;

    if (isChecked) {
      newStatus = [...newStatus, vle];
      setFilterCounter((c) => ({
        ...c,
        byStatusCount: c.byStatusCount + 1,
      }));
    } else {
      setFilterCounter((c) => ({
        ...c,
        byStatusCount: c.byStatusCount - 1,
      }));
      newStatus = newStatus.filter((ns) => ns !== vle);
    }

    if (newStatus.length === 0) {
      newStatus = allStatusArray;
      setIsDefaultStatus(true);
    } else {
      setIsDefaultStatus(false);
    }

    setContactFilters((oldFilter) => ({
      ...oldFilter,
      status: newStatus,
    }));
  }

  useEffect(() => {
    setIsDefaultStatus(_.isEqual(allStatusArray, contactFilters.status));
  }, []);

  const memorizedStatus = useMemo(
    () => (
      <>
        {STATUS.map((status) => (
          <ItemDiv
            onClick={() =>
              onFilterStatusChange(
                status.value as ContactStatus,
                !(
                  !isDefaultStatus &&
                  contactFilters.status.includes(status.value as ContactStatus)
                )
              )
            }
          >
            <StyledCheckBox
              key={`sidebar_checkbox_${status.name}`}
              check={
                !isDefaultStatus &&
                contactFilters.status.includes(status.value as ContactStatus)
              }
              handleCheck={() => {
                onFilterStatusChange(
                  status.value as ContactStatus,
                  !(
                    !isDefaultStatus &&
                    contactFilters.status.includes(
                      status.value as ContactStatus
                    )
                  )
                );
              }}
            />
            <FilterName>{status.name}</FilterName>
          </ItemDiv>
        ))}
      </>
    ),
    [isDefaultStatus, contactFilters.status]
  );

  return memorizedStatus;
}
